const UNSET_TIMESTAMP_YEAR = 1;

export function isTimestampSet(value: string | undefined): boolean {
  return !!value && new Date(value).getUTCFullYear() > UNSET_TIMESTAMP_YEAR;
}

export function isToday(value: string | undefined): boolean {
  if (!isTimestampSet(value)) {
    return false;
  }

  const date = new Date(value as string);
  const today = new Date();
  return date.getFullYear() === today.getFullYear()
    && date.getMonth() === today.getMonth()
    && date.getDate() === today.getDate();
}

export function isTimestampBefore(value: string | undefined, reference: string): boolean {
  return isTimestampSet(value) && new Date(value as string).getTime() < new Date(reference).getTime();
}

export function isTimestampAfter(value: string | undefined, reference: string): boolean {
  return isTimestampSet(value) && new Date(value as string).getTime() > new Date(reference).getTime();
}

export function startOfTodayIso(): string {
  const today = new Date();
  return new Date(today.getFullYear(), today.getMonth(), today.getDate()).toISOString();
}

export function toDateInputValue(value: string | undefined): string {
  if (!isTimestampSet(value)) {
    return '';
  }

  const date = new Date(value as string);
  const month = `${date.getMonth() + 1}`.padStart(2, '0');
  const day = `${date.getDate()}`.padStart(2, '0');
  return `${date.getFullYear()}-${month}-${day}`;
}

export function dateInputValueToIso(value: string): string {
  const [year, month, day] = value.split('-').map(Number);
  return new Date(year, month - 1, day).toISOString();
}
